/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Action_Edit_Number_LabelInputs */

const fr_vehicle_action_edit_number_label = /** @type {(inputs: Vehicle_Action_Edit_Number_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numéro du véhicule`)
};

const en_vehicle_action_edit_number_label = /** @type {(inputs: Vehicle_Action_Edit_Number_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vehicle number`)
};

/**
* | output |
* | --- |
* | "Vehicle number" |
*
* @param {Vehicle_Action_Edit_Number_LabelInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_action_edit_number_label = /** @type {((inputs?: Vehicle_Action_Edit_Number_LabelInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Action_Edit_Number_LabelInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_action_edit_number_label(inputs)
	return en_vehicle_action_edit_number_label(inputs)
});